(function($){


$('.header__nav-button').click(function(){

  $('body').toggleClass('open-menu')

  $('.menu').toggleClass('open')

})

$('.page-overlay').click(function(){

  $('body').removeClass('open-menu')

  $('.menu').removeClass('open')
})



$(document).ready(function() {
  $('ul.accordion').accordion();
  $('ul.accordion li a').eq(0).trigger('click');
});

 





$('.logo-slide').slick({
  slidesToShow: 10,
 //variableWidth: true,
  infinite: true,
 // rows: 2,
  slidesToShow: 10,
  autoplay: true,
  dots: false,
  arrows: false,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  responsive: [

    {

      breakpoint: 992,

      settings: {

        slidesToShow: 6

      }

    },
    {

      breakpoint: 767,

      settings: {
        
        slidesToShow: 3

      }

    }

  ]
  
});



$('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  fade: true,
  asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots: false,
  arrows: false,
  centerMode: false,
  focusOnSelect: true,
  responsive: [
    {

      breakpoint: 640,

      settings: {
        
        slidesToShow: 4,
        slidesToScroll: 1

      }

    }

  ]
});
		


$('.testimonial_slide').slick({

  dots: true,

  arrows: true,

  infinite: true,

  prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M20.5 11.1113H8.33L13.92 5.52133L12.5 4.11133L4.5 12.1113L12.5 20.1113L13.91 18.7013L8.33 13.1113H20.5V11.1113Z' fill='CurrentColor'/></svg></button>",

  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M8.5 0.111328L7.09 1.52133L12.67 7.11133H0.5V9.11133H12.67L7.09 14.7013L8.5 16.1113L16.5 8.11133L8.5 0.111328Z' fill='currentcolor'/></svg></button>",

  slidesToShow:3,
  responsive: [

    {

      breakpoint: 992,

      settings: {

        slidesToShow: 2

      }

    },
    {

      breakpoint: 767,

      settings: {
        
        slidesToShow: 1,
        arrows: false,
        centerMode: true,
    centerPadding: '16px'

      }

    }

  ]

});



$('.tab-menu li a').on('click', function(){

  var target = $(this).attr('data-rel');

$('.tab-menu li a').removeClass('active');

  $(this).addClass('active');

  $("#"+target).fadeIn('slow').siblings(".tab-box").hide();

  return false;

});




$('.blog-imggg > a').each(function(){

  $(this).find('img').hide();

  var _Bg = 'url('+ $(this).find('img').attr('src') + ')';

  $(this).css("background-image", _Bg);

  $(this).find('img').hide();

}); 






















  









})(jQuery);

 $(document).ready(function () {
    $('#mySelect').on('change', function () {
      // Get the selected value
      var selectedValue = $(this).val();

      // Redirect to another page with the selected value as a URL parameter
      window.location.href = "/pages/compliance-check?selected=" + encodeURIComponent(selectedValue);
    });
   $('.compliance_form button').on('click', function(event){
     event.preventDefault();
      // Get the selected value
     
      var selectedValue = $('#state').val();
 
      // Redirect to another page with the selected value as a URL parameter
      window.location.href = "/pages/compliance-check?selected=" + encodeURIComponent(selectedValue);
    });
  });

 $(document).ready(function () {
    // Get the URL parameter 'selected'
    const params = new URLSearchParams(window.location.search);
    const selectedValue = params.get('selected');
console.log(selectedValue);
   $('state').html(selectedValue);
    if (selectedValue) {
      // Show the div with the matching ID and hide others
      $('.content-diva').hide();
     // Hide all divs with the class 'content-div'
      $('#' + selectedValue.toLowerCase().replace(/\s+/g, '-')).show(); // Show the div with the matching ID
        var pro_handlee = '/products/' + selectedValue.toLowerCase().replace(/\s+/g, '-') + '-2025-state-labor-law-poster';
$('.ctaturl').attr('href', pro_handlee);
      $('#mySelect2').val(selectedValue.toLowerCase().replace(/\s+/g, '-'));
    }

    var savedValue = localStorage.getItem('selectedValue');

  // Show the corresponding div based on the saved value
  if (savedValue) {
     // Hide all content-divs
    
  } else {
     setTimeout(function() {
  if (jQuery('#entry-Popup').length) {
    jQuery.magnificPopup.open({
     items: {
         src: '#entry-Popup' 
     },
     type: 'inline',
     fixedContentPos: 'false'
       
          });
    }
  }, 10000);
    localStorage.setItem('selectedValue', 'popup');
  }
    
  });

$('.modal-link').magnificPopup({
  type: 'inline',
  midClick: true,
  mainClass: 'mfp-fade'
});


 
        $(document).ready(function () {
            $('#linkSelect').on('change', function () {
                const selectedLink = $(this).val();
                if (selectedLink) {
                    window.open(selectedLink, '_self'); // Open link in a new tab
                }
            });
            $('#linkSelect2').on('change', function () {
                const selectedLink = $(this).val();
                if (selectedLink) {
                    window.open(selectedLink, '_self'); // Open link in a new tab
                }
            });
        });

  $(".remnewa").on("click", function(e) {
    $(this).parents(".single").addClass("is-loading");

    var main_datee = $(this).data("time");

    e.preventDefault();
console.log(main_datee);
    var itemsArray = [];

    $(".single").each(function() {
      if ($(this).hasClass("timestam")) {
        var datee = $(this).data("time");
        var variant = $(this).data("variant");
 
        if(main_datee == datee) {
          itemsArray.push(variant);
        }
      }
    });
 
    var qty = 0;
    var data = {
      updates: {}
    };

    for (var i = 0; i < itemsArray.length; i++) {
      data.updates[itemsArray[i]] = qty;
    }
   jQuery.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: data,
      dataType: "json",
      success: Shopify.onSuccess,
      error: Shopify.onError
    });
  });

(Shopify.onSuccess = function () {
                 location.reload();
              });
  

$(document).ready(function() {
    $('#mySelect2').on('change', function() {
        var selectedValue = $(this).val(); // Get the selected value
        $('.content-diva').hide(); // Hide all divs with class 'content-div'
      $('.content-diva').removeClass('a' + selectedValue);
        console.log('a' + selectedValue);
        if (selectedValue) {
            $('#' + selectedValue).show(); // Show the div with matching ID
        }
      if (selectedValue == 'all') {
$('.content-diva').show();
      }
    });
});

$(document).ready(function () {
    // Select the parent container of the <div> elements
    var container = $('#parent-container'); // Replace with your actual parent container ID or class

    // Get all child <div> elements
    var divs = container.children('div');

    // Sort the <div> elements alphabetically based on their ID
    divs.sort(function (a, b) {
        var idA = $(a).attr('id').toLowerCase();
        var idB = $(b).attr('id').toLowerCase();
        return idA.localeCompare(idB);
    });

    // Append the sorted <div> elements back to the parent container
    container.append(divs);

    console.log("Div elements sorted alphabetically by ID.");
});




